import { createAction } from 'redux-actions';
const ns = 'main-menu/';

export const toggleMainMenuOpen = createAction<boolean>(`${ns}TOGGLE_OPEN`);
